import React, { SVGProps } from 'react';

/**
 * viewBox='0 0 24 24' er den faktiske størrelsen på svg'en. De to siste veridene må være svgen sin
 * faktiske bredde og høyde. Hvis ikke vil svg'en bli strukket til å fylle hele plassen den har.
 * widt og height er satt til 100% for å fylle hele plassen den har.
 * @param props
 * @constructor
 */
interface SvgProps extends SVGProps<SVGSVGElement> {
	pathFill?: string;
	color?: string;
}

export const OverbygningPilOpp: React.FC<SvgProps> = ({ pathFill = '#077197', ...props }) => {
	return (
		<svg
			width='100%'
			height='100%'
			viewBox='0 0 104 64'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<path
				id='Vector 99'
				d='M101.333 0L98.232 4.8697L104 5.12084L101.333 0ZM1.8335 64C1.8335 55.4235 5.66332 48.134 13.5388 42.9667C21.438 37.7838 33.4334 34.7222 49.7546 34.7222V33.7222C33.3303 33.7222 21.1151 36.7996 12.9902 42.1306C4.84148 47.4772 0.833496 55.0765 0.833496 64H1.8335ZM49.7546 34.7222C65.1788 34.7222 77.6075 33.0143 86.4539 28.3858C95.3481 23.7323 100.583 16.146 101.636 4.54427L100.64 4.45392C99.616 15.7379 94.5655 23.0132 85.9904 27.4998C77.3674 32.0114 65.1427 33.7222 49.7546 33.7222V34.7222Z'
				fill={pathFill}
			/>
		</svg>
	);
};
